document.addEventListener('alpine:init', () => {
  function productFormToolbar(data = {}) {
    return {
      ...data,

      isEnabled_: true,

      get isEnabled() {
        return this.isIntersectedFormContainer && this.isEnabled_;
      },

      init() {
        document.addEventListener('productformactionsintersectenter', () => {
          this.isEnabled_ = false;
        });

        document.addEventListener('productformactionsintersectleave', () => {
          this.isEnabled_ = true;
        });
      }
    };
  };

  Alpine.data('productFormToolbar', productFormToolbar);
});
